<small style="position: fixed" class="debug">{{me}}</small>
<div>
  <div class="cardInner">
    <br/>
    <div>
      @if (dynamicsInitialized) {
        <div class="noScroll">
          <dynamic-form [fields]="uiConfigInit" class="noScroll" (submit)="submit($event)">
          </dynamic-form>
        </div>
      }
    </div>
  </div>
  <br/>
  <br/>
  <br/>
</div>

<!--        <mat-form-field>-->
<!--            <input matInput [disabled]="readOnly" class="rateInput" [(ngModel)]="m_clickEventParam" (change)="dispatchEventsAll()">-->
<!--        </mat-form-field>-->
<!--        <button class="icon-button buttonBarButt" mat-button (click)="openSceneRemove();">-->
<!--            <mat-icon>remove</mat-icon>-->
<!--        </button>-->
